import {IChanges, IClientId} from '../interfaces/undoRedoInterfaces';

export default class UndoRedoHelper {
  static handleDestroy(json: any, changes: IChanges, isForward: boolean = true) {
    for (const client_id in changes._destroy) {
      const destroyedItemsSorted = this.destroyedItemsSorted(changes._destroy[client_id], isForward);
      for (const child of destroyedItemsSorted) {
        const parentRoot: string = `${child.parentRoot}_attributes`;
        const val = isForward ? child.newVal : child.oldVal;
        if (child.isArray) {
          json[parentRoot] = json[parentRoot] || [];
          if (val) {
            this.pushOrReplace(json[parentRoot], val);
          } else {
            this.pushOrReplace(json[parentRoot],{client_id: client_id, _destroy: true});
          }
        } else {
          if (val) {
            json[parentRoot] = val;
          } else {
            json[parentRoot] = {client_id: client_id, _destroy: true};
          }
        }
      }
    }
  }

  static destroyedItemsSorted<T>(destroyedItems: Array<T>, isForward: boolean): Array<T> {
    const clone = destroyedItems.slice();
    if (!isForward) {
      clone.reverse();
    }
    return clone;
  }

  static pushOrReplace<T extends IClientId>(items: T[], newItem: T): void {
    if (!items.find) {
      console.error("the class items represent probably needs collectionRoot set on it")
    }
    const existingItem = items.find(item => item.client_id === newItem.client_id);
    if (existingItem) {
      items[items.indexOf(existingItem)] = newItem;
    } else {
      items.push(newItem);
    }
  }
}